module.exports = __webpack_public_path__ + "img/funnel-empty-state.aec4d667.png";